import { FC, Fragment } from "react";
import { Controller, useFormContext } from "react-hook-form";
// i18next
import { useTranslation } from "react-i18next";
// Types
import QuizTypes from "types/QuizTypes";
// Components
import { Select } from "components/Controls";

type Props = {
  questionIndex: number;
}

const TimeoutField:FC<Props> = ({ questionIndex }) => {
  const {t} = useTranslation();

  const { control, watch } = useFormContext();

  const quizType = watch('type');

  const questionTimeoutOptions = [
    { label: t('labels.none'), value: '' },
    ...[5, 10, 15, 20, 25, 30, 60, 90, 120, 240, 300].map(e => ({ label: e.toString(), value: e }))
  ];

  if (![QuizTypes.Scoring, QuizTypes.Prediction, QuizTypes.BeatTheExpert, QuizTypes.Streak].includes(quizType)) return null;
  return (
    <Fragment>
      <Controller
        control={control} name={`questions.${questionIndex}.timeout`}
        render={({ field }) => (
          <Select
            {...field}
            label={t('pages.quizForm.questionTimeoutLabel')} id="questionTimeout" name="questionTimeout"
            options={questionTimeoutOptions}
          />
        )}
      />
      <span className="block text-gray-400 text-sm font-light leading-5 mb-4">{t('pages.quizForm.questionTimeoutHint')}</span>
    </Fragment>
  )
}

export default TimeoutField;
